export const validateMin = (value: string, min: number) => {
    const numValue = parseFloat(value);
    if (numValue < min) {
      return min;
    } else {
      return numValue;
    }
}